export const getUserRole = () => {
  return localStorage.getItem("FENTASAFE_ROLE");
};

export const setUserRole = (role) => {
  localStorage.setItem("FENTASAFE_ROLE", role);
};

export const clearUserRole = () => {
  localStorage.removeItem("FENTASAFE_ROLE");
};

export const hasRole = (allowedRoles) => {
  const role = getUserRole();
  return allowedRoles.includes(role);
};